/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, forEach, get } from "lodash";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
  createWorkScheduleAssign,
  deleteWorkScheduleAssign,
} from "../../../../apis/work-schedule";
import Icon from "../../../../components/Icon";
import { ControlTable } from "../../../../components/Table";
import { getFutureDay } from "../../../../utils/date";
import { searchEmployee } from "../../../../utils/employee";
import { getParamsOld } from "../../../../utils/params";
// icon
import CompanyIcon from "../../../../assets/images/icon/company24x24.svg";
import FolderIcon from "../../../../assets/images/icon/folder24x24.svg";
// import UserProfileIcon from "../../../../assets/images/icon/user-profile.svg";
import ApplyDate from "./ApplyDate";
import Profile from "../../../../components/Profile";

const WorkScheduleTable = ({
  title,
  api,
  apiFilter = {},
  dataKey,
  tableInfo,
  setDetailOpen,
  setWorkscheduleData,
  setMode,
  permission
}) => {
  const { user, parts, company, employees, companies } = useSelector(
    (store) => ({
      companies: store.Data.companies,
      user: store.Profile.user,
      company: store.Profile.company,
      parts: store.Data.parts,
      employees: store.Data.employees,
    }),
    shallowEqual
  );

  const [fields, setFields] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [targetList, setTargetList] = useState([]);
  // 상세
  const [open, setOpen] = useState(false);
  const [defaultDate, setDefaultDate] = useState([]);
  const [assignIdxs, setAssignIdxs] = useState([]);

  useEffect(() => {
    submit();
    setIsFirst(false);
  }, [page, limit]);

  useEffect(() => {
    if (isFirst) return;
    if (page === 0) submit();
    else setPage(0);
  }, []);

  useEffect(() => {
    setFields([
      {
        title: "적용대상",
        key: "employeeIdx",
        onValue: (value, field, data) => {
          let target;
          switch (data.assignedAs) {
            case "company":
              if (!isEmpty(companies) && !isEmpty(user)) {
                target = (
                  <>
                    <Icon src={CompanyIcon} />
                    <span
                      className="margin-left-4"
                      style={{ verticalAlign: "middle" }}
                    >
                      {
                        get(company, 'name')
                      }
                    </span>
                  </>
                );
              }
              break;
            case "part":
              if (!isEmpty(parts)) {
                target = (
                  <>
                    <Icon src={FolderIcon} />
                    <span
                      className="margin-left-4"
                      style={{ verticalAlign: "middle" }}
                    >
                      {parts.find((part) => part.idx === data.partIdx).partName}
                    </span>
                  </>
                );
              }
              break;
            case "person":
              if (!isEmpty(employees)) {
                const employee = employees.find(
                  (employee) => employee.idx === data.employeeIdx
                )
                target = (
                  <>
                    <Profile data={employee}></Profile>
                  </>
                );
              }
              break;
            default:
              break;
          }

          return target;
        },
      },
      { title: "적용일", key: "applyStartDate" },
    ]);
  }, [parts, employees, user, companies]);

  const submit = (_params = {}) => {
    setIsLoading(true);
    api({
      ...apiFilter,
      ...getParamsOld({ page, limit }),
    }).then((response) => {
      setIsLoading(false);
      setTotal(response.data.total);
      setList(response.data[dataKey]);
    });
  };

  // 테이블 버튼
  const tableButtons = [
    {
      label: "근무일정 수정",
      color: "gray-line",
      action: () => {
        setDetailOpen(true);
        setWorkscheduleData(tableInfo);
        setMode("modify");
      },
    },
    {
      label: "적용대상 추가",
      color: "gray-line",
      action: () => {
        searchEmployee((employees) => {
          setTargetList(employees);
        }, list.map(e => e.employeeIdx), { isPartView: true });
      },
    },
  ];

  // 테이블 로우 체크시 테이블 버튼
  const selectedTableButtons = [
    {
      label: "선택삭제",
      color: "line",
      action: () => {
        const deleteList = {
          assignIdxs: [],
        };

        forEach(selectedList, (selected) => {
          deleteList.assignIdxs.push(selected.assignIdx);
        });

        deleteWorkScheduleAssign(deleteList).then(() => {
          submit();
        });
      },
    },
    {
      label: "적용일 수정",
      color: "line",
      action: () => {
        const idxs = [];
        forEach(selectedList, (selected) => {
          idxs.push(selected.assignIdx);
        });

        setAssignIdxs(idxs);
        setDefaultDate("");
        setOpen(true);
      },
    },
  ];

  // 조회 권한용 테이블 버튼
  const viewTableButtons = [
    {
      label: "근무일정 보기",
      color: "gray-line",
      action: () => {
        setDetailOpen(true);
        setWorkscheduleData(tableInfo);
        setMode("view");
      },
    },
  ]

  useEffect(() => {
    if (!isEmpty(targetList)) {
      const employeeIdx = [];
      const partIdx = [];
      const newEmployeeList = targetList.filter(({ idx: id1 }) => !list.some(({ employeeIdx: id2 }) => id1 === id2))
      forEach(newEmployeeList, (target) => {
        if (target.isPart) {
          partIdx.push(target.idx);
        }
        if (target.isEmployee) {
          employeeIdx.push(target.idx);
        }
      });

      const formData = {
        scheduleIdx: tableInfo.idx,
        applyStartDate: getFutureDay(),
        partIdxs: !isEmpty(partIdx) ? partIdx : undefined,
        employeeIdxs: !isEmpty(employeeIdx) ? employeeIdx : undefined,
        assignAsCompany: undefined,
      };
      createWorkScheduleAssign(formData).then(() => {
        submit();
        setTargetList([]);
      });
    }
  }, [targetList]);

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        className: "float-right",
        action: (data) => {
          setDefaultDate(data.applyStartDate);
          setAssignIdxs([data.assignIdx]);
          setOpen(true);
        },
      },
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8 float-right",
        action: (data) => {
          deleteWorkScheduleAssign({ assignIdxs: [data.assignIdx] }).then(
            () => {
              submit();
            }
          );
        },
      },
    ],
  };

  return (
    <>
      <ControlTable
        isLoading={isLoading}
        isOpenToggle={true}
        title={
          <span>
            {title}
            <span style={{ marginLeft: "8px", color: "#21D4A9", fontWeight: "bold" }}>
              {list.length || 0}
            </span>
            명
          </span>
        }
        fields={fields}
        list={list}
        buttons={permission.level > 1 ? (isEmpty(selectedList) ? tableButtons : selectedTableButtons) : viewTableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
        isControl={permission.level > 1}
      />
      <ApplyDate
        open={open}
        setOpen={setOpen}
        defaultDate={defaultDate}
        submit={submit}
        selectedList={assignIdxs}
      />
    </>
  );
};

export default WorkScheduleTable;
